
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class GWattMinModal extends Vue {

    @Prop({
        default: () => new OM.GWattMinModel()
    }) model: OM.GWattMinModel;

    localModel: OM.GWattMinModel = new OM.GWattMinModel();

    @Prop() callback: any;

    created() {
        this.localModel = this.model;
    }

    get canSave(){
        return this.localModel.grams.key && this.localModel.watt.key && this.localModel.minutes.key;
    }

    save() {
        if(!this.canSave)
            return;

        this.callback(this.localModel);
    }
    
}
